import React, { useState, useRef, useEffect } from 'react';
import {JOURNEYS, PAGES, prependJourneyToRouteName} from "../constants";
import LoadingPage from "../Pages/Shared/LoadingPage";
import PersonalDetailsPage from "../Pages/Shared/PersonalDetailsPage";
import BusinessDetailsPage from "../Pages/Shared/BusinessDetailsPage";
import CongratulationsPage from "../Pages/Shared/CongratulationsPage";
import StripeSubscriptionPage from "../Pages/Shared/StripeSubscriptionPage";

const AgentJourney = (props) => {
    const [currentPage, setCurrentPage]         = useState(PAGES.LOADING);

    useEffect(() => {
        customerPageDetails();
    }, []);

    const customerPageDetails = () => {
        axios.get(route(prependJourneyToRouteName(JOURNEYS.AGENT, 'session.page-details.get'), {session: window.session}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    if (!!response.data.current_page) {
                        setCurrentPage(response.data.current_page);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const previousPage = () => {
        switch (currentPage) {
            case PAGES.LOADING:
            case PAGES.PERSONAL_DETAILS:
                // Start of journey
                break;
            case PAGES.BUSINESS_DETAILS:
                setCurrentPage(PAGES.PERSONAL_DETAILS);
                break;
            case PAGES.STRIPE_SUBSCRIPTION:
                setCurrentPage(PAGES.BUSINESS_DETAILS);
                break;
            case PAGES.CONGRATULATIONS:
                // End of journey
                break;
        }
    }

    const nextPage = () => {
        switch (currentPage) {
            case PAGES.LOADING:
                setCurrentPage(PAGES.PERSONAL_DETAILS);
                break;
            case PAGES.PERSONAL_DETAILS:
                setCurrentPage(PAGES.BUSINESS_DETAILS);
                break;
            case PAGES.BUSINESS_DETAILS:
                setCurrentPage(PAGES.STRIPE_SUBSCRIPTION);
                break;
            case PAGES.STRIPE_SUBSCRIPTION:
                setCurrentPage(PAGES.CONGRATULATIONS);
                break;
            case PAGES.CONGRATULATIONS:
                // End of journey
                break;
        }
    }

    const renderPage = () => {
        switch (currentPage) {
            case PAGES.LOADING:
                return (
                    <LoadingPage
                        nextPage={() => nextPage()}
                        journey={JOURNEYS.AGENT}
                    />
                );
            case PAGES.PERSONAL_DETAILS:
                return (
                    <PersonalDetailsPage
                        nextPage={() => nextPage()}
                        journey={JOURNEYS.AGENT}
                    />
                );
            case PAGES.BUSINESS_DETAILS:
                return (
                    <BusinessDetailsPage
                        previousPage={() => previousPage()}
                        nextPage={() => nextPage()}
                        journey={JOURNEYS.AGENT}
                    />
                );
            case PAGES.STRIPE_SUBSCRIPTION:
                return (
                    <StripeSubscriptionPage
                        previousPage={() => previousPage()}
                        nextPage={() => nextPage()}
                        journey={JOURNEYS.AGENT}
                    />
                );
            case PAGES.CONGRATULATIONS:
                return (
                    <CongratulationsPage
                        previousPage={() => previousPage()}
                        journey={JOURNEYS.AGENT}
                    />
                );
        }
    }

    return renderPage();
}

export default AgentJourney;
